import { Flex } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { StatCardsContainer } from "components";
import { getBuyingGroupStatistics } from "screens/WebsiteVisitorTracking/screens/WebAnalytics/WebAnalytics.requests";
import { Props } from "screens/WebsiteVisitorTracking/screens/WebAnalytics/WebAnalytics.types";

export const BuyingGroupStatistics = ({
  pixelId,
  accountView,
  campaignId,
  startDate,
  endDate,
  accountsIds,
}: Pick<
  Props,
  | "pixelId"
  | "accountView"
  | "campaignId"
  | "startDate"
  | "endDate"
  | "accountsIds"
>) => {
  const buyingGroupStatistics = useQuery(
    [
      "buyingGroupStatistics",
      pixelId,
      accountView,
      campaignId,
      startDate,
      endDate,
      accountsIds,
    ],
    () =>
      getBuyingGroupStatistics(
        pixelId,
        accountView,
        campaignId,
        startDate,
        endDate,
        accountsIds
      ),
    {
      enabled: Boolean(pixelId && accountView && startDate && endDate),
    }
  );

  return (
    <Flex width="100%" gap={4} direction={"column"}>
      <Flex width="100%">
        <StatCardsContainer
          items={[
            {
              isLoading:
                buyingGroupStatistics.isLoading ||
                buyingGroupStatistics.isFetching,
              title: "Percentage of total web traffic from Personas",
              value: buyingGroupStatistics.data?.personaTargetedPageVisits ?? 0,
              valueFormatter: (value) => `${value}%`,
              noValueMessage: "No historical data available.",
            },
            {
              isLoading:
                buyingGroupStatistics.isLoading ||
                buyingGroupStatistics.isFetching,
              title: "Buying Group Contacts from Visiting Personas",
              value: buyingGroupStatistics.data?.countContacts,
              noValueMessage: "No historical data available.",
              caption:
                "Contacts have been found within your buying group criteria who visited your website",
            },
          ]}
        />
      </Flex>
    </Flex>
  );
};
